<div class="text-center">
  <mat-spinner style="margin: auto"></mat-spinner>
</div>
